import { render, staticRenderFns } from "./status_select.vue?vue&type=template&id=2a83a59e&"
import script from "./status_select.vue?vue&type=script&lang=js&"
export * from "./status_select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports